import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/fertility/fertility-app-for-couples/#webpage",
   "url": "https://www.futurefamilyai.com/fertility/fertility-app-for-couples/",
   "name": "Fertility Wellness App for Couples | FutureFamilyAI",
   "description": "Plan together while respecting individual privacy: shared goals and appointments, opt-in health sharing, and optional couple carrier screening.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Pooja Patel, MD",
    "jobTitle": "Surrogacy & Fertility Content Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#pooja-patel",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "IVF & Fertility Preparation",
     "item": "https://www.futurefamilyai.com/fertility/ivf-preparation/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Fertility App for Couples",
     "item": "https://www.futurefamilyai.com/fertility/fertility-app-for-couples/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Is there a fertility app for couples?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. FutureFamilyAI supports partners planning together with per-person privacy."
     }
    },
    {
     "@type": "Question",
     "name": "Can my partner see my health data?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Only if you share it."
     }
    },
    {
     "@type": "Question",
     "name": "Does it track ovulation?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "FutureFamilyAI focuses on wellness and blood pressure, not ovulation prediction."
     }
    },
    {
     "@type": "Question",
     "name": "Can men use FutureFamilyAI?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, as a partner for shared planning and carrier screening."
     }
    },
    {
     "@type": "Question",
     "name": "Does it diagnose infertility?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. See a clinician for fertility evaluation."
     }
    },
    {
     "@type": "Question",
     "name": "Is couple carrier screening included?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "It's an optional add-on priced separately."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function FertilityFertilityAppForCouplesPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/fertility/ivf-preparation">
                IVF &amp; Fertility Preparation
              </Link>
              <span>›</span>
              <span>Fertility App for Couples</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                A fertility wellness app for couples should help partners plan
                together while keeping each person&apos;s health data private
                unless they choose to share.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Planning couples</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      ACOG recommends offering carrier screening for cystic
                      fibrosis and spinal muscular atrophy to everyone who is
                      considering pregnancy or is pregnant. (ACOG Committee
                      Opinion No. 691, 2017)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Shared plan, separate privacy · Couple carrier-screening
                      summary · Same app into pregnancy
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">FERTILITY GUIDE</span>
            <h1>Fertility Wellness App for Couples — Plan Together</h1>
            <p className="ffh-answer speakable-content">
              A fertility wellness app for couples should help partners plan
              together while keeping each person&apos;s health data private
              unless they choose to share. FutureFamilyAI supports shared goals,
              appointments and optional couple carrier screening, with explicit,
              per-person sharing. App trends do not replace fertility
              evaluation. Each partner can join free during the pilot through
              December 31, 2026, and the same app continues into pregnancy.
              Start planning together.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#pooja-patel">Dr. Pooja Patel, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
              <Link className="ffh-btn ffh-ghost" to="/contact-us?type=member">
                Request Free Pilot Access
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Couple planning their family together with FutureFamilyAI"
              >
                <figcaption>
                  <b>Photo slot</b> · Couple cooking together in a bright
                  kitchen, laughing, phone propped on the counter. No text.
                  <br />
                  <b>Alt:</b> Couple planning their family together with
                  FutureFamilyAI
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    ACOG recommends offering carrier screening for cystic
                    fibrosis and spinal muscular atrophy to everyone who is
                    considering pregnancy or is pregnant.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/committee-opinion/articles/2017/03/carrier-screening-for-genetic-conditions">
                        ACOG Committee Opinion No. 691, 2017
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>Plan together</h2>
                <ul>
                  <li>Shared appointments and reminders</li>
                  <li>Joint questions for your clinician</li>
                  <li>Optional couple carrier screening</li>
                </ul>
              </section>
              <section id="s2">
                <h2>Privacy for each partner</h2>
                <p>
                  Each partner controls their own data and decides what to
                  share.
                </p>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>Is there a fertility app for couples?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Yes. FutureFamilyAI supports partners planning together
                        with per-person privacy.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can my partner see my health data?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>Only if you share it.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Does it track ovulation?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        FutureFamilyAI focuses on wellness and blood pressure,
                        not ovulation prediction.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can men use FutureFamilyAI?</summary>
                    <div className="ffh-ans">
                      <p>
                        Yes, as a partner for shared planning and carrier
                        screening.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Does it diagnose infertility?</summary>
                    <div className="ffh-ans">
                      <p>No. See a clinician for fertility evaluation.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Is couple carrier screening included?</summary>
                    <div className="ffh-ans">
                      <p>It&apos;s an optional add-on priced separately.</p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">PP</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Pooja Patel, MD</h3>
                  <p>
                    Surrogacy &amp; Fertility Content Author, FutureFamilyAI.
                    Dr. Pooja Patel, MD, writes FutureFamilyAI&apos;s surrogacy
                    and fertility content. Her work across the Surrogacy4All
                    network focuses on gestational carriers, IVF preparation and
                    family-building pathways.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/fertility/ivf-preparation">
                    IVF &amp; Fertility Preparation →
                  </Link>
                  <Link to="/fertility/preconception-wellness-tracking">
                    Preconception Wellness Tracking →
                  </Link>
                  <Link to="/fertility/ivf-blood-pressure-monitoring">
                    Blood Pressure During IVF →
                  </Link>
                  <Link to="/fertility/egg-donor-family-planning">
                    Egg Donor Family Planning →
                  </Link>
                  <Link to="/fertility/canada-ivf-wellness-support">
                    Canada IVF Wellness Support →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.eggdonors4all.com">
                    https://www.eggdonors4all.com →
                  </a>
                  <a href="https://www.indianeggdonors.com">
                    https://www.indianeggdonors.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">Plan together</a>
                  </li>
                  <li>
                    <a href="#s2">Privacy for each partner</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
